/** Google Business Profile / Maps listing used for review CTAs. */
export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/search/?api=1&query=Intygsl%C3%A4karen+J%C3%A4rntorgsgatan+8+G%C3%B6teborg";
